import React, { useEffect, useState, useContext } from "react";
// import "../../../assets/UFC_DC_V3/scss/modules/custom.scss";
import "../../assets/UFC_DC_V3/scss/modules/anim.scss";
import "../../assets/UFC_DC_V3/scss/modules/checklist.scss";
import "../../assets/UFC_DC_V3/scss/modules/personaldetails.scss";
import "../../assets/UFC_DC_V3/scss/modules/questionnaire.scss";
import { FormProvider, useForm } from "react-hook-form";
import QueryStringContext from "../../Contexts/QueryString";
import Footer from '../Includes/Layouts/UFC_DC_4_2/Footer';
import GetVisitorsParams from "../../Utility/GetVisitorsParams";
import Questions from "../Includes/Layouts/UFC_DC_4_2/Questions";
import UkCreditRating from "../Includes/Layouts/UFC_DC_V4/UkCreditRating";
import Loader from "../Includes/Layouts/UFC_DC_V4/Loader";
import PersonalDetails from "../Includes/Layouts/UFC_DC_V4/PersonalDetails";
import { useClaimReg } from "../../Hooks/useClaimReg";
import bg_money_sml from "../../assets/UFC_DC_V1/img/bg-money-sml.png";
import logo_white from "../../assets/UFC_DC_V1/img/logo-white.png";

const CreditQuest_UFC_DC_4_2 = () => {
    const { queryString } = useContext(QueryStringContext);
    const [showUkc, setShowUkc] = useState(false); // Start with false, show after form is filled
    const [showQuestions, setShowQuestions] = useState(false);
    const [showLoader, setShowLoader] = useState("");
    const [previousAddressData, setPreviousAddressData] = useState({});
    const [agreement, setAgreement] = useState(false);
    const [signatureDataURL, setSignatureDataURL] = useState("");
    const [ukcCompleted, setUkcCompleted] = useState(false); // Track UKC completion status
    const { nextButtonClick } = useClaimReg();

    // Load form data from localStorage if available
    const getStoredFormData = () => {
        try {
            const storedData = localStorage.getItem('formData');
            return storedData ? JSON.parse(storedData) : {};
        } catch (error) {
            console.error('Error parsing stored form data:', error);
            return {};
        }
    };

    const formMethods = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
        defaultValues: getStoredFormData(),
        resolver: undefined,
        context: undefined,
        criteriaMode: "firstError",
        shouldFocusError: true,
        shouldUnregister: true,
    });

    const handleUkcStatusChange = (status) => {
        // Set UKC as completed when status indicates completion
        if (status === 'completed' || status === 'success' || status === 'finished' || status === 'account-exists' || status === 'active' || status === 'manual') {
            setUkcCompleted(true);
        }
    };

    // Log user details being passed to UkCreditRating
    const logUserDetails = () => {
        const formData = formMethods.getValues();
        
        // Log specific fields that UkCreditRating expects
        const expectedFields = [
            'lstSalutation', 'txtFName', 'txtLName', 'txtEmail', 'txtPhone',
            'txtHouseNumber', 'txtAddress2', 'address1', 'txtStreet', 'txtTown', 'txtPostCode'
        ];
        
        // Log DOB fields from DOM
        const dobDay = document.getElementById("DobDay")?.value;
        const dobMonth = document.getElementById("DobMonth")?.value;
        const dobYear = document.getElementById("DobYear")?.value;
    };

    const handleNextToQuestions = async () => {
        try {
            // Get UUID from URL or localStorage
            const urlParams = new URLSearchParams(window.location.search);
            const uuid = urlParams.get('uuid') || localStorage.getItem('uuid');
            
            // Call the nextButtonClick API
            await nextButtonClick(
                uuid,
                'UFC_DC_4_2',
                'UK_rating_next'
            );
            
            setShowUkc(false);
            setShowQuestions(true);
        } catch (error) {
            // Still proceed with the UI change even if API fails
            setShowUkc(false);
            setShowQuestions(true);
        }
    };

    // Check if form data exists and auto-show UKC if form is already filled
    useEffect(() => {
        const storedData = getStoredFormData();
        const requiredFields = ['lstSalutation', 'txtFName', 'txtLName', 'txtEmail', 'txtPhone', 'txtPostCode', 'address1'];
        const isFormFilled = requiredFields.every(field => storedData[field] && storedData[field].trim() !== '');
        
        if (isFormFilled) {
            setShowUkc(true);
        }
    }, []);

    // Log user details when UKC component is shown
    useEffect(() => {
        if (showUkc) {
            logUserDetails();
        }
    }, [showUkc]);

    return (
        <FormProvider {...formMethods}>
            <div className='UFC_DC_V3'>
                <GetVisitorsParams />
                
                <Loader showLoader={showLoader} />
                
                {/* Hidden form fields to provide data to UkCreditRating */}
                <div style={{ display: 'none' }}>
                    <input {...formMethods.register('lstSalutation')} />
                    <input {...formMethods.register('txtFName')} />
                    <input {...formMethods.register('txtLName')} />
                    <input {...formMethods.register('txtEmail')} />
                    <input {...formMethods.register('txtPhone')} />
                    <input {...formMethods.register('txtHouseNumber')} />
                    <input {...formMethods.register('txtAddress2')} />
                    <input {...formMethods.register('address1')} />
                    <input {...formMethods.register('txtStreet')} />
                    <input {...formMethods.register('txtTown')} />
                    <input {...formMethods.register('txtPostCode')} />
                    <select {...formMethods.register('DobDay')}>
                        <option value="">Day</option>
                    </select>
                    <select {...formMethods.register('DobMonth')}>
                        <option value="">Month</option>
                    </select>
                    <select {...formMethods.register('DobYear')}>
                        <option value="">Year</option>
                    </select>
                </div>
                
                {showUkc && (
                    <section className={`banner parallax-container`}>
                        <div className="d-lg-none d-md-none d-sm-block d-block money-bg-mobile">
                            <img src={bg_money_sml} alt="" />
                        </div>
                        <div className="container">
                            <div>
                                <div className="brand">
                                    <div className="logo pt-3">
                                        <a href="index.html">
                                            <img src={logo_white} height="60" alt="" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container pt-5 px-lg-2 px-md-2 px-sm-0 px-0">
                            <div className="inner-section">
                                <div className="body-questionnaire mb-4">
                                    <div className="inner rounded-4">
                                        <div className="swiper qsSlider slide-up-now">
                                            <div className="swiper-wrapper">
                                                <div className="swiper-slide slide-up-now">
                                                    <h2 className="qs-title">
                                                        Please complete the UK Credit Rating check below
                                                    </h2>
                                                    <div className="ms-lg-5 ms-md-3 ms-0 ps-lg-4 ps-md-3 ps-sm-2 ps-0 pt-lg-2 pt-md-4 pt-sm-2 pt-2 below-text">
                                                        <div className="mt-2 d-flex align-items-center">
                                                            <div>
                                                                This helps us verify your identity and find the best refund options for you.
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="ukc-container mt-4">
                                                        <UkCreditRating
                                                            show={showUkc}
                                                            onStatusChange={handleUkcStatusChange}
                                                            setShowLoader={setShowLoader}
                                                        />
                                                    </div>
                                                    <div className="text-center mt-4 mb-4">
                                                        <button 
                                                            className={`btn btn-primary btn-lg px-5 ${!ukcCompleted ? 'disabled' : ''}`}
                                                            onClick={handleNextToQuestions}
                                                            disabled={!ukcCompleted}
                                                        >
                                                            Next
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                )}
                
                {showQuestions && <Questions/>}
                
                <Footer />
            </div>
        </FormProvider>
    )
}

export default CreditQuest_UFC_DC_4_2;